import { CLIENT } from "../types";

export interface IClient {
  id: string;
  clientName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  city: string;
  addressLine1: string;
  postCode: string;
  provinceShortCode: string;
  status: string;
  craBusinessNo: string;
  invoicePaymentFor: number;
  transactionMethod: number;
  scheduleStartDate: string | null;
  superUserFieldsShownInClientSetup: boolean;
}

const initialState: IClient = {
  id: "",
  clientName: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  city: "",
  addressLine1: "",
  postCode: "",
  provinceShortCode: "",
  status: "",
  craBusinessNo: "",
  invoicePaymentFor: 10,
  transactionMethod: 200,
  scheduleStartDate: null,
  superUserFieldsShownInClientSetup: false,
};

export const clientReducer = (
  state: IClient = initialState,
  action: any,
): IClient => {
  switch (action.type) {
    case CLIENT.CLIENT_SET_SELECTED:
      return {
        ...state,
        id: action.payload.id,
        clientName: action.payload.legalName,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        email: action.payload.email,
        phone: action.payload.phone,
        city: action.payload.city,
        addressLine1: action.payload.addressLine1,
        postCode: action.payload.postCode,
        provinceShortCode: action.payload.provinceShortCode,
        status: action.payload.status,
        craBusinessNo: action.payload.craBusinessNo,
        invoicePaymentFor: action.payload.invoicePaymentFor,
        transactionMethod: action.payload.transactionMethod,
        scheduleStartDate: action.payload.scheduleStartDate,
        superUserFieldsShownInClientSetup:
          action.payload.superUserFieldsShownInClientSetup,
      };

    case CLIENT.CLIENT_CLEAR_SELECTED:
      return {
        ...state,
        id: "",
        clientName: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        city: "",
        addressLine1: "",
        postCode: "",
        provinceShortCode: "",
        status: "",
        craBusinessNo: "",
        invoicePaymentFor: 10,
        transactionMethod: 200,
        scheduleStartDate: null,
        superUserFieldsShownInClientSetup: false,
      };
    case CLIENT.CLIENT_NAME_SET_SELECTED:
      return {
        ...state,
        clientName: action.payload.clientName,
      };
    case CLIENT.CLIENT_NAME_CLEAR_SELECTED:
      return {
        ...state,
        clientName: "",
      };

    default:
      return state;
  }
};
